import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=88042efc"
import script from "./teams.vue?vue&type=script&lang=js"
export * from "./teams.vue?vue&type=script&lang=js"
import style0 from "./teams.vue?vue&type=style&index=0&id=88042efc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports